import { render, staticRenderFns } from "./PasswordTab.vue?vue&type=template&id=5aaef1eb"
import script from "./PasswordTab.vue?vue&type=script&lang=js"
export * from "./PasswordTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports